var t={name:"rzFooterBlock",props:{contactsTitle:{type:String,default:"Поддержка клиентов"},linksTitle:{type:String,default:"Разделы сайта"}}};export{t as default};
